import { useState } from "react";

/* COMPONENTS */
import DatePicker from "react-datepicker";

/* PHILIPPINE LOCATIONS */
import useLocationData from "../../../../hooks/useLocationData";

/* CSS */

import '../../../../styles/stepper.css'



const Page1 = ({ formData, setFormData, nextPage }) => {

  const [regions, setRegions] = useState([]);



  const { provinces, cityMunicipalities, barangays, loadingProvinces, loadingCities, loadingBarangays, setProvinces, setCityMunicipalities, setBarangays } = useLocationData(formData);

  const [errors, setErrors] = useState({});
  const validate = () => {
    const newErrors = {};

    const fields = [
      'lawyerFirstName',
      'lawyerLastName',
      'lawyerMiddleName',
      'lawyerBirthday',
      // 'lawyerPlaceOfBirth',
      'lawyerGender',
      'lawyerCivilStatus',
      'country',
      'region',
      'province',
      'cityMunicipality',
      'barangay',
      'lawyerContactNumber',
      'lawyerEmail',
      'lawyerPassword',
      'lawyerConfirmPassword'
    ];


    const formatFieldName = (field) => {
      return field
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // Split camelCase (e.g., "firstName" -> "First name")
        .replace(/^./, (str) => str.toUpperCase());  // Capitalize the first letter
    };

    // Loop through the fields and check if they're empty
    fields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${formatFieldName(field)} is required.`; // Dynamic error message
      }
    });


  // ✅ Additional check: password match
  if (
    formData.lawyerPassword &&
    formData.lawyerConfirmPassword &&
    formData.lawyerPassword !== formData.lawyerConfirmPassword
  ) {
    newErrors.lawyerConfirmPassword = "Passwords do not match.";
    newErrors.lawyerPassword = "Passwords do not match.";
  }

  console.log(newErrors);

    // Update state with errors
    setErrors(newErrors);


    // Scroll to the first invalid element
    setTimeout(() => {
      const firstInvalidElement = document.querySelector('.invalid-feedback');
      if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalidElement.focus?.();
      }
    }, 0);

    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };


  const handleNext = () => {
    if (validate()) {
      nextPage();
    }
  };



  // Handle changes to each dropdown
  const handleRegionChange = (event) => {
    console.log("gg");
    setFormData((prev) => ({ ...prev, province: "" }));
    setFormData((prev) => ({ ...prev, cityMunicipality: "" }));
    setFormData((prev) => ({ ...prev, barangay: "" }));

    setFormData((prev) => ({ ...prev, region: event.target.value }));
  };

  const handleProvinceChange = (event) => {
    setFormData((prev) => ({ ...prev, cityMunicipality: "" }));
    setFormData((prev) => ({ ...prev, barangay: "" }));
    setFormData((prev) => ({ ...prev, province: event.target.value }));
  };

  const handleCityMunicipalityChange = (event) => {
    setFormData((prev) => ({ ...prev, barangay: "" }));
    setFormData((prev) => ({ ...prev, cityMunicipality: event.target.value }));
  };

  const handleBarangayChange = (event) => {
    setFormData((prev) => ({ ...prev, barangay: event.target.value }));
  };

  const handleDateChange = (date, key) => {
    setFormData({
      ...formData,
      [key]: date ? date : "",
    });
  };





  return (
    <div className="step-content">
      <div className="row mb-4">
        

        <div className="col-md-12">
          <div className="row">


             <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column justify-content-center">
                <h5 className="mb-1">Lawyer's Information</h5>
                <p className="mb-1"><span className="fw-medium">Fill-up info</span></p>
              </div>
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerFirstName" >
                First Name
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.lawyerFirstName && errors.lawyerFirstName && 'is-invalid'}`}
                id="lawyerFirstName"
                value={formData.lawyerFirstName}
                name="lawyerFirstName"
                placeholder="Enter First Name"
                aria-label="First Name"
                onChange={(e) => setFormData({ ...formData, lawyerFirstName: e.target.value })}
              />
              {!formData.lawyerFirstName && errors.lawyerFirstName && <div className="invalid-feedback d-block blink">{errors.lawyerFirstName}</div>}

            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerMiddleName" >
                Middle Name
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.lawyerMiddleName && errors.lawyerMiddleName && 'is-invalid'}`}
                id="lawyerMiddleName"
                value={formData.lawyerMiddleName}
                name="lawyerMiddleName"
                placeholder="Enter Middle Name (Optional)"
                aria-label="Middle Name"
                onChange={(e) => setFormData({ ...formData, lawyerMiddleName: e.target.value })}
              />
              {!formData.lawyerMiddleName && errors.lawyerMiddleName && <div className="invalid-feedback d-block blink">{errors.lawyerMiddleName}</div>}

            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerLastName" >
                Last Name
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.lawyerLastName && errors.lawyerLastName && 'is-invalid'}`}
                id="lawyerLastName"
                value={formData.lawyerLastName}
                name="lawyerLastName"
                placeholder="Enter Last Name"
                aria-label="Last Name"
                onChange={(e) => setFormData({ ...formData, lawyerLastName: e.target.value })}
              />
              {!formData.lawyerLastName && errors.lawyerLastName && <div className="invalid-feedback d-block blink">{errors.lawyerLastName}</div>}

            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerSuffix" >
                Suffix <span className="text-danger">( Optional )</span>
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.lawyerSuffix && errors.lawyerSuffix && 'is-invalid'}`}
                id="lawyerSuffix"
                value={formData.lawyerSuffix}
                name="lawyerSuffix"
                placeholder="Example: Jr, Sr"
                aria-label="Suffix"
                onChange={(e) => setFormData({ ...formData, lawyerSuffix: e.target.value })}
              />
              {!formData.lawyerSuffix && errors.lawyerSuffix && <div className="invalid-feedback d-block blink">{errors.lawyerSuffix}</div>}
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info d-block " htmlFor="lawyerBirthday" >
                Date of Birth
              </label>

 

              <DatePicker
                id="lawyerBirthday"
                name="lawyerBirthday"
                className={`form-control text-capitalize flatpickr-input active w-100 mt-n1 ${!formData.lawyerBirthday && errors.lawyerBirthday && 'is-invalid'}`}
                placeholderText="YYYY-MM-DD"

                // selected={formData.lawyerBirthday}
                 selected={formData.lawyerBirthday ? new Date(formData.lawyerBirthday) : null}

                onChange={(date) => handleDateChange(date, "lawyerBirthday")}

                dateFormat="yyyy-MM-dd"

                showYearDropdown
                showMonthDropdown
                dropdownMode="select"

                minDate={new Date('1940-01-01')}
                maxDate={new Date()}


              />
              {!formData.lawyerBirthday && errors.lawyerBirthday && <div className="invalid-feedback d-block blink">{errors.lawyerBirthday}</div>}
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="lawyerPlaceOfBirth" >
                Place of Birth <span className="text-danger">( Optional )</span>
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.lawyerPlaceOfBirth && errors.lawyerPlaceOfBirth && 'is-invalid'}`}
                id="lawyerPlaceOfBirth"
                value={formData.lawyerPlaceOfBirth}
                name="lawyerPlaceOfBirth"
                placeholder="Place of Birth"
                aria-label="Place of Birth"
                onChange={(e) => setFormData({ ...formData, lawyerPlaceOfBirth: e.target.value })}
              />
              {!formData.lawyerPlaceOfBirth && errors.lawyerPlaceOfBirth && <div className="invalid-feedback d-block blink">{errors.lawyerPlaceOfBirth}</div>}
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="lawyerGender" >
                Gender
              </label>

              <select
                id="lawyerGender"
                className={`select2 form-select ${!formData.lawyerGender && errors.lawyerGender && 'is-invalid'}`}
                data-placeholder="Select Gender"
                value={formData.lawyerGender}
                name="lawyerGender"
                onChange={(e) => setFormData({ ...formData, lawyerGender: e.target.value })}
              >
                <option value="">Gender</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
              {!formData.lawyerGender && errors.lawyerGender && <div className="invalid-feedback d-block blink">{errors.lawyerGender}</div>}
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="lawyerCivilStatus" >
                Civil Status
              </label>

              <select
                id="lawyerCivilStatus"
                className={`select2 form-select ${!formData.lawyerCivilStatus && errors.lawyerCivilStatus && 'is-invalid'}`}
                data-placeholder="Select Civil Status"
                value={formData.lawyerCivilStatus}
                name="lawyerCivilStatus"
                onChange={(e) => setFormData({ ...formData, lawyerCivilStatus: e.target.value })}>

                <option value="">Civil Status</option>
                <option value="SINGLE">Single</option>
                <option value="MARRIED">Married</option>
                <option value="SEPARATED">Separated</option>
                <option value="WIDOWED">Widowed</option>
              </select>
              {!formData.lawyerCivilStatus && errors.lawyerCivilStatus && <div className="invalid-feedback d-block blink">{errors.lawyerCivilStatus}</div>}
            </div>



             {/* PRESENT ADDRESS */}


            <div className="d-flex flex-wrap justify-content-between align-items-center mt-4">
              <div className="d-flex flex-column justify-content-center">
                <h5 className="mb-1">Address Information</h5>
                <p className="mb-1"><span className="fw-medium">Enter present address.</span></p>
              </div>
            </div>



            {/* COUNTRY */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="country" >
                Country
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.country && errors.country && 'is-invalid'}`}
                id="country"
                value={formData.country ?? "Philippines"}
                name="country"
                placeholder="Enter Country"
                aria-label="Country"
                onChange={(e) => setFormData({ ...formData, country: e.target.value })}

              />
            </div>

            {/* REGION */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="region" >
                Region
              </label>

              <select
                id="region"
                className={`select2 form-select ${!formData.region && errors.region && 'is-invalid'}`}
                data-placeholder="Select Region"
                value={formData.region}
                name="region"
                onChange={handleRegionChange}
              >
                <option value="">Region</option>

                <option value="NATIONAL CAPITAL REGION (NCR)">NATIONAL CAPITAL REGION (NCR)</option>
                <option value="CORDILLERA ADMINISTRATIVE REGION (CAR)">CORDILLERA ADMINISTRATIVE REGION (CAR)</option>
                <option value="REGION I (ILOCOS REGION)">REGION I (ILOCOS REGION)</option>
                <option value="REGION II (CAGAYAN VALLEY)">REGION II (CAGAYAN VALLEY)</option>
                <option value="REGION III (CENTRAL LUZON)">REGION III (CENTRAL LUZON)</option>
                <option value="REGION IV-A (CALABARZON)">REGION IV-A (CALABARZON)</option>
                <option value="REGION IV-B (MIMAROPA)">REGION IV-B (MIMAROPA)</option>
                <option value="REGION V (BICOL REGION)">REGION V (BICOL REGION)</option>
                <option value="REGION VI (WESTERN VISAYAS)">REGION VI (WESTERN VISAYAS)</option>
                <option value="REGION VII (CENTRAL VISAYAS)">REGION VII (CENTRAL VISAYAS)</option>
                <option value="REGION VIII (EASTERN VISAYAS)">REGION VIII (EASTERN VISAYAS)</option>
                <option value="REGION IX (ZAMBOANGA PENINSULA)">REGION IX (ZAMBOANGA PENINSULA)</option>
                <option value="REGION X (NORTHERN MINDANAO)">REGION X (NORTHERN MINDANAO)</option>
                <option value="REGION XI (DAVAO REGION)">REGION XI (DAVAO REGION)</option>
                <option value="REGION XII (SOCCSKSARGEN)">REGION XII (SOCCSKSARGEN)</option>
                <option value="REGION XIII (Caraga)">REGION XIII (Caraga)</option>
                <option value="AUTONOMOUS REGION IN MUSLIM MINDANAO (ARMM)">AUTONOMOUS REGION IN MUSLIM MINDANAO (ARMM)</option>

              </select>
              {!formData.region && errors.region && <div className="invalid-feedback d-block blink">{errors.region}</div>}
            </div>

            {/* PROVINCE */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="province" >
                Province
              </label>

              <select
                id="province"
                className={`select2 form-select ${!formData.province && errors.province && 'is-invalid'}`}
                data-placeholder="Select Province"
                value={formData.province}
                name="province"
                onChange={handleProvinceChange}
                disabled={loadingProvinces}
              >


                {loadingProvinces ? (
                  <option value="" disabled selected>
                    <span className="spinner"></span> Select Region first...
                  </option>
                ) : (
                  <>
                    <option value="">Select Province</option>
                    {
                      provinces.map((prov, index) => (
                        <option key={index} value={prov.province}>
                          {prov.province}
                        </option>
                      ))
                    }
                  </>
                )}

              </select>
              {!formData.province && errors.province && <div className="invalid-feedback d-block blink">{errors.province}</div>}
            </div>

            {/* CITY/MUNICIPALITY */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="cityMunicipality" >
                City/Municipality
              </label>

              <select
                id="cityMunicipality"
                className={`select2 form-select ${!formData.cityMunicipality && errors.cityMunicipality && 'is-invalid'}`}
                data-placeholder="Select City/Municipality"
                value={formData.cityMunicipality}
                name="cityMunicipality"
                onChange={handleCityMunicipalityChange}
                disabled={loadingCities}
              >

                {loadingCities ? (
                  <option value="" disabled selected>
                    <span className="spinner"></span> Select Province first...
                  </option>
                ) : (
                  <>
                    <option value="">Select City / Municipality</option>
                    {cityMunicipalities.map((city, index) => (
                      <option key={index} value={city.city_municipality}>
                        {city.city_municipality}
                      </option>
                    ))}
                  </>
                )}


              </select>
              {!formData.cityMunicipality && errors.cityMunicipality && <div className="invalid-feedback d-block blink">{errors.cityMunicipality}</div>}
            </div>

            {/* BARANGAY */}
            <div className="col-md-12 mb-2">
              <label className="form-label text-info mb-1" htmlFor="barangay" >
                Barangay
              </label>

              <select
                id="barangay"
                className={`select2 form-select ${!formData.barangay && errors.barangay && 'is-invalid'}`}
                data-placeholder="Select Barangay"
                value={formData.barangay}
                name="barangay"
                onChange={handleBarangayChange}
                disabled={loadingBarangays}>
                {loadingBarangays ? (
                  <option value="" disabled selected>
                    <span className="spinner"></span> Select City/Municipality first...
                  </option>
                ) : (
                  <>
                    <option value="">Select Barangay</option>
                    {barangays.map((brgy, index) => (
                      <option key={index} value={brgy.barangay}>
                        {brgy.barangay}
                      </option>
                    ))}
                  </>
                )
                }
              </select>
              {!formData.barangay && errors.barangay && <div className="invalid-feedback d-block blink">{errors.barangay}</div>}
            </div>

             <div className="col-md-12 mb-2">
              <label className="form-label text-info" htmlFor="lawyerAddress" >
                Address
              </label>
              <input
                type="text"
                className={`form-control text-capitalize mt-n1 ${!formData.lawyerAddress && errors.lawyerAddress && 'is-invalid'}`}
                id="lawyerAddress"
                value={formData.lawyerAddress}
                name="lawyerAddress"
                placeholder="Enter Address"
                aria-label="Address"
                onChange={(e) => setFormData({ ...formData, lawyerAddress: e.target.value })}
              />
              {!formData.lawyerAddress && errors.lawyerAddress && <div className="invalid-feedback d-block blink">{errors.lawyerAddress}</div>}

            </div>


     


       
            {/* CONTACT INFO */}
             <div className="d-flex flex-wrap justify-content-between align-items-center mt-4">
                <div className="d-flex flex-column justify-content-center">
                  <h5 className="mb-1">Contact Information</h5>
                </div>
              </div>

              <div className="col-md-6">
                <label className="form-label text-info" htmlFor="lawyerContactNumber" >
                  Contact Number
                </label>
                <input
                  type="text"
                  className={`form-control text-capitalize mt-n1 ${!formData.lawyerContactNumber && errors.lawyerContactNumber && 'is-invalid'}`}
                  id="lawyerContactNumber"
                  value={formData.lawyerContactNumber}
                  name="lawyerContactNumber"
                  placeholder="Enter Contact Number"
                  aria-label="Contact Number"
                  onChange={(e) => setFormData({ ...formData, lawyerContactNumber: e.target.value })}
                />
              {!formData.lawyerContactNumber && errors.lawyerContactNumber && <div className="invalid-feedback d-block blink">{errors.lawyerContactNumber}</div>}

              </div>

              <div className="col-md-6">
                <label className="form-label text-info" htmlFor="txtEmail" >
                  Email Address
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.lawyerEmail && errors.lawyerEmail && 'is-invalid'}`}
                  id="txtEmail"
                  value={formData.lawyerEmail}
                  name="lawyerEmail"
                  placeholder="Enter Email Address"
                  aria-label="Email Address"
                  onChange={(e) => setFormData({ ...formData, lawyerEmail: e.target.value })}
                />
              {!formData.lawyerEmail && errors.lawyerEmail && <div className="invalid-feedback d-block blink">{errors.lawyerEmail}</div>}

              </div>


              <div className="col-md-6">
                <label className="form-label text-info" htmlFor="txtPassword" >
                  Enter Password
                </label>
                <input
                  type="password"
                  className={`form-control mt-n1 ${!formData.lawyerPassword && errors.lawyerPassword && 'is-invalid'}`}
                  id="txtPassword"
                  value={formData.lawyerPassword}
                  name="lawyerPassword"
                  placeholder="Password"
                  aria-label="Password"
                  onChange={(e) => setFormData({ ...formData, lawyerPassword: e.target.value })}
                />
              
              </div>

            <div className="col-md-6">
              <label className="form-label text-info" htmlFor="txtConfirmPassword" >
                Confirm Password
              </label>
              <input
                type="password"
                className={`form-control mt-n1 ${!formData.lawyerConfirmPassword && errors.lawyerConfirmPassword && 'is-invalid'}`}
                id="txtConfirmPassword"
                value={formData.lawyerConfirmPassword}
                name="lawyerConfirmPassword"
                placeholder="Confirm Password"
                aria-label="Confirm Password"
                onChange={(e) => setFormData({ ...formData, lawyerConfirmPassword: e.target.value })}
              />
              {(!formData.lawyerConfirmPassword || errors.lawyerConfirmPassword) && <div className="invalid-feedback d-block blink">{errors.lawyerConfirmPassword}</div>}

            </div>
             

          </div>






        </div>

       
      </div>



      <div className="col-12 d-flex justify-content-end">
        <button className="btn btn-primary btn-next" onClick={handleNext}>
          <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
            Next
          </span>
          <i className="bx bx-chevron-right bx-sm me-sm-n2" />
        </button>
      </div>

    </div>
  );
};

export default Page1;
